import { css, keyframes } from '@emotion/css';

const scaleAnimation = keyframes`
  from {
    transform: scale(0.8);
  }
  to {
    transform: scale(1);
  }
`;

export const bookmarkAnimationStyles = css`
  animation: ${scaleAnimation} 0.5s;
`;
